<template>
  <div class="cardCon cardConRuleEditor">
    <ButtonGroup type="button" v-model="type">
      <Button :type="type == item.id ? 'primary' : 'default'" @click=selectFn(item) v-for="(item, index) in data"
        :key="index" :label="item.id">{{
            item.title
        }}</Button>
    </ButtonGroup>
    <div class="formCon f12">
      <Form :label-width="120" v-if="type == 0">
        <FormItem label="父进程">
          <Select style="width:160px;" v-model="parentProVal">
            <Option v-for="(item, index) in perPoress" :value="item.value" :key="index">{{ item.label }}</Option>
          </Select>
          <Input v-if="parentProVal != 'null'" v-model="parentVal" class="margin6" :class="{ error: parentError }"
            style="width:340px;margin-left: -1px;" :placeholder="parentPsw"></Input>
          <Checkbox border class="checkBg " v-model="matchProc" v-if="action != 2">匹配子进程</Checkbox>
        </FormItem>
        <FormItem label="子进程">
          <Select style="width:160px;" v-model="childProVal">
            <Option v-for="(item, index) in perPoress" v-show="index != 0" :value="item.value" :key="index">{{
                item.label
            }}</Option>
          </Select>
          <Input style="width:340px;margin-left: -1px;" :class="{ error: childrenError }" v-model="childVal"
            :placeholder="childPsw"></Input>
        </FormItem>
        <FormItem label="匹配子进程级数" class="" v-if="matchProc && action != 2">
          <InputNumber style="width:380px;" :class="{ error: childNumEro }" v-model="childNum"
            placeholder="1~65534代表父进程的第几个子进程" />
        </FormItem>
      </Form>
      <Form :label-width="120" v-if="type == 13">
        <FormItem label="进程">
          <Select style="width:160px;" v-model="parentProVal">
            <Option v-for="(item, index) in perPoressLine" :value="item.value" :key="index">{{ item.label }}</Option>
          </Select>
          <Input v-if="parentProVal != 'null'" v-model="parentVal" class="margin6" :class="{ error: parentError }"
            style="width:360px;margin-left: -1px;" :placeholder="parentPsw"></Input>
            <!-- <Checkbox border class="checkBg " v-model="matchProc" v-if="action != 2">匹配子进程</Checkbox> -->
            <template v-if="(action !='patch_target')">
              匹配子进程级数：<InputNumber style="width:100px; border-radius:0;" :class="{ error: childNumEro }" v-model="childNum"
              placeholder="1~65534代表父进程的第几个子进程" />
            </template>
        </FormItem>
        <!-- <FormItem label="匹配子进程级数" class="" v-if="matchProc && action != 2">
          <InputNumber style="width:520px; border-radius:0;" :class="{ error: childNumEro }" v-model="childNum"
            placeholder="1~65534代表父进程的第几个子进程" />
        </FormItem> -->
        <FormItem label="模块">
          <Select style=" width:160px;" v-model="childProVal">
            <Option v-for="(item, index) in driveList2" :value="item.value" :key="index">{{
                item.label
            }}</Option>
          </Select>
          <Input style="width:360px;margin-left: -1px;" :class="{ error: childrenError }" v-model="childVal"
            :placeholder="childPsw"></Input>

        </FormItem>
        <FormItem label="线程特征">
          <Select v-model="threadType" style=" width:160px;" >
            <Option value="1">偏移量</Option>
            <Option value="2" :disabled="action =='patch_target'">线程序号</Option>
          </Select>
          <template v-if="(threadType ==1)">
            <Input style="width:160px;margin-left: -1px;" v-model="Offset" placeholder="请输入偏移量"></Input>
            <!-- <Checkbox border class="checkBg " v-model="isDelay">是否延时</Checkbox> -->
            <!-- <template v-if="isDelay">
            </template> -->
            延时：<InputNumber v-model="Delay" style="width:100px;" :min="10"/>毫秒
          </template>
          <template v-else>
            <Input style="width:160px;margin-left: -1px;margin-right:10px;" v-model="index" placeholder="请输入线程序号" ></Input>
            延时：<InputNumber v-model="Delay" style="width:100px;" :min="10"/>毫秒
          </template>
        </FormItem>
      </Form>
      <Form :label-width="120" v-else-if="type == 5">
        <FormItem label="进程">
          <Select style="width:160px;" v-model="parentProVal">
            <Option v-for="(item, index) in perPoress" :value="item.value" :key="index">{{ item.label }}</Option>
          </Select>
          <Input v-if="parentProVal != 'null'" :class="{ error: parentError }" :placeholder="parentPsw"
            v-model="parentVal" class="margin6" style="width:340px;margin-left: -1px;"></Input>
          <!-- <Checkbox border class="checkBg " v-model="matchProc" v-if="action != 2">匹配子进程</Checkbox> -->
        </FormItem>
        <FormItem label="匹配子进程级数" class="" v-if="matchProc && action != 2">
          <InputNumber style="width:380px;" :class="{ error: childNumEro }" v-model="childNum"
            placeholder="1~65534代表父进程的第几个子进程" />
        </FormItem>
        <FormItem label="驱动">
          <Select style="width:160px;" v-model="childProVal">
            <Option v-for="(item, index) in driveList" :value="item.value" :key="index">{{
                item.label
            }}</Option>
          </Select>
          <Input style="width:340px;margin-left: -1px;" v-model="childVal" :placeholder="childPsw"
            :class="{ error: childrenError }"></Input>
        </FormItem>
      </Form>
      <Form :label-width="120" v-else-if="type == 2">
        <FormItem label="进程">
          <Select style="width:160px;" v-model="parentProVal">
            <Option v-for="(item, index) in perPoress" :value="item.value" :key="index">{{ item.label }}</Option>
          </Select>
          <Input v-if="parentProVal != 'null'" :class="{ error: parentError }" v-model="parentVal" class="margin6"
            style="width:340px;margin-left: -1px;" :placeholder="parentPsw"></Input>
          <Checkbox border class="checkBg " v-model="matchProc" v-if="action != 2">匹配子进程</Checkbox>
        </FormItem>
        <FormItem label="匹配子进程级数" class="" v-if="matchProc && action != 2">
          <InputNumber style="width:380px;" :class="{ error: childNumEro }" v-model="childNum"
            placeholder="1~65534代表父进程的第几个子进程" />
        </FormItem>
        <FormItem label="模块">
          <Select style="width:160px;" v-model="childProVal">
            <Option v-for="(item, index) in driveList2" :value="item.value" :key="index">{{
                item.label
            }}</Option>
          </Select>
          <Input :class="{ error: childrenError }" style="width:340px;margin-left: -1px;" v-model="childVal"
            :placeholder="childPsw"></Input>
        </FormItem>

      </Form>
      <Form :label-width="120" v-else-if="type == 1">
        <FormItem label="进程">
          <Select style="width:160px;" v-model="parentProVal">
            <template v-for="item in perPoress">
              <Option :value="item.value" :key="item.value"
                :disabled="(action == 3 && item.value == 'Sign') || (action == 3 && item.value == 'SignName')  || (action == 4 && item.value =='Sign') || (action == 4 && item.value =='SignName')|| (action == 4 && item.value =='Hash')|| (action == 4 && item.value =='MD5')">{{
                    item.label
                }}</Option>
            </template>
          </Select>
          <Input v-if="parentProVal != 'null'" :class="{ error: parentError }" v-model="parentVal" class="margin6"
            style="width:340px;margin-left: -1px;" :placeholder="parentPsw"></Input>
          <Checkbox border class="checkBg " v-model="matchProc" v-if="action != 2 && action !=4">匹配子进程</Checkbox>
        </FormItem>
        <FormItem label="匹配子进程级数" class="" v-if="matchProc && action != 2">
          <InputNumber style="width:380px;" :class="{ error: childNumEro }" v-model="childNum"
            placeholder="1~65534代表父进程的第几个子进程" />
        </FormItem>
        <FormItem label="文件">
          <Select style="width:160px;" v-model="childProVal">
            <Option v-for="(item, index) in fileList" :value="item.value" :key="index">{{
                item.label
            }}</Option>
          </Select>
          <Input style="width:340px;margin-left: -1px;" :class="{ error: childrenError }" v-model="childVal"
            :placeholder="childPsw"></Input>
        </FormItem>
        <FormItem label="文件权限" v-if="action!=4">
          <Checkbox-group v-model="fileAction">
            <Checkbox style="margin-right:10px;" v-for="(item, index) in fileActionList" :key="index"
              :label="item.value"><span style="padding-left:6px;">{{ item.label
              }}</span>
            </Checkbox>
          </Checkbox-group>
        </FormItem>
      </Form>
      <Form :label-width="120" v-else-if="type == 4">
        <FormItem label="进程">
          <Select style="width:160px;" v-model="parentProVal">
            <Option v-for="(item, index) in perPoress" :value="item.value" :key="index">{{ item.label }}</Option>
          </Select>
          <Input v-if="parentProVal != 'null'" :class="{ error: parentError }" v-model="parentVal" class="margin6"
            style="width:340px;margin-left: -1px;" :placeholder="parentPsw"></Input>
          <Checkbox border class="checkBg " v-model="matchProc" v-if="action != 2">匹配子进程</Checkbox>
        </FormItem>
        <FormItem label="匹配子进程级数" class="" v-if="matchProc && action != 2">
          <InputNumber style="width:380px;" :class="{ error: childNumEro }" v-model="childNum"
            placeholder="1~65534代表父进程的第几个子进程" />
        </FormItem>
        <FormItem label="键值路径">
          <Select style="width:160px;" v-model="childProVal">
            <Option v-for="(item, index) in regList" :value="item.value" :key="index">{{
                item.label
            }}</Option>
          </Select>
          <Input v-if="childProVal != 'null'" style="width:340px;margin-left: -1px;" v-model="childVal"
            :placeholder="childPsw"></Input>
        </FormItem>
        <FormItem label="注册表权限">
          <Checkbox-group v-model="fileAction">
            <Checkbox style="margin-right:10px;" v-for="(item, index) in regActionList" :key="index"
              :label="item.value"><span style="padding-left:6px;">{{ item.label
              }}</span>
            </Checkbox>
          </Checkbox-group>
        </FormItem>
      </Form>
      <Form :label-width="120" v-else-if="type == 3">
        <FormItem label="进程">
          <Select style="width:160px;" v-model="parentProVal">
            <Option v-for="(item, index) in perPoress" :value="item.value" :key="index">{{ item.label }}</Option>
          </Select>
          <Input v-if="parentProVal != 'null'" :class="{ error: parentError }" v-model="parentVal" class="margin6"
            style="width:340px;margin-left: -1px;" :placeholder="parentPsw"></Input>
          <Checkbox border class="checkBg " v-model="matchProc" v-if="action != 2">匹配子进程</Checkbox>
        </FormItem>
        <FormItem label="匹配子进程级数" class="" v-if="matchProc && action != 2">
          <InputNumber style="width:380px;" :class="{ error: childNumEro }" v-model="childNum"
            placeholder="1~65534代表父进程的第几个子进程" />
        </FormItem>
        <FormItem label="目标地址">
          <Select style="width:90px;" v-model="childProVal">
            <Option v-for="item in tagetList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <Input style="width:230px;margin-left: -1px;" v-model="ipVal" :class="{ error: childrenError }"
            placeholder="仅支持半角数字、小数点及通配符*和?"></Input>
          <Button disabled style="margin-left:10px;">端口</Button>
          <Input style="width:180px;margin-left: -1px;" v-model="portVal" :class="{ error: portError }"
            placeholder="仅支持半角数字及通配符*和?"></Input>
        </FormItem>
        <FormItem label="协议支持">
          <CheckboxGroup v-model="fileAction">
            <Checkbox label="TCP"><span style="padding-left:6px;">TCP</span></Checkbox>
            <Checkbox label="UDP"><span style="padding-left:6px;">UDP</span></Checkbox>
            <Checkbox label="ICMP"><span style="padding-left:6px;">ICMP</span></Checkbox>
          </CheckboxGroup>
        </FormItem>
      </Form>
      <Form :label-width="120" v-else-if="type == 6">
        <FormItem label="驱动">
          <Select style="width:160px;" v-model="parentProVal">
            <Option v-for="(item, index) in callList" :value="item.value" :key="index">{{ item.label }}</Option>
          </Select>
          <Input v-if="parentProVal != 'null'" :class="{ error: parentError }" v-model="parentVal" class="margin6"
            style="width:340px;margin-left: -1px;" :placeholder="parentPsw"></Input>
        </FormItem>
        <FormItem label="回调类型">
          <Select style="width:160px;" v-model="childProVal">
            <Option v-for="item in callBackList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
      </Form>
      <Form :label-width="120" v-else-if="type == 8">
        <FormItem label="进程">
          <Select style="width:160px;" v-model="parentProVal">
            <Option v-for="(item, index) in perPoress" v-show="index != 0" :value="item.value" :key="index">{{
                item.label
            }}</Option>
          </Select>
          <Input v-if="parentProVal != 'null'" :class="{ error: parentError }" v-model="parentVal" class="margin6"
            style="width:340px;margin-left: -1px;" :placeholder="parentPsw"></Input>
        </FormItem>
        <FormItem label="窗口标题">
          <Input style="width:518px;" placeholder="支持null及通配符*和?" :class="{ error: childrenError3 }" v-model="title" />
        </FormItem>
        <FormItem label="窗口类名">
          <Input style="width:518px;" placeholder="支持null及通配符*和?" :class="{ error: childrenError4 }" v-model="calss" />
        </FormItem>
        <FormItem label="窗口宽度">
          <Input style="width:194px;" :class="{ error: childrenError }" placeholder="半角数字、支持通配符*和?" v-model="width" />
          <span class="tar" style="width:120px;display: inline-block;margin-right: 10px;">窗口高度</span>
          <Input style="width:194px;" :class="{ error: childrenError2 }" placeholder="半角数字、支持通配符*和?" v-model="height" />
        </FormItem>
        <!-- <FormItem label="窗口X坐标">
          <Input style="width:194px;" placeholder="xVal" />
          <span class="tar" style="width:120px;display: inline-block;margin-right: 10px;">窗口Y坐标</span>
          <Input style="width:194px;" placeholder="" v-model="yVal" />
        </FormItem> -->
        <FormItem label="窗口样式">
          <Input style="width:194px;" placeholder="支持null及通配符*和?" :class="{ error: childrenError5 }" v-model="style" />
          <span class="tar" style="width:120px;display: inline-block;margin-right: 10px;">窗口扩展样式</span>
          <Input style="width:194px;" placeholder="支持null及通配符*和?" :class="{ error: childrenError6 }" v-model="style1" />
        </FormItem>
      </Form>
      <Form :label-width="120" v-else-if="type == 7">
        <FormItem label="注入进程">
          <Select style="width:160px;">
            <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <Input style="width:340px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
          <Checkbox border class="checkBg" v-if="action != 2">匹配子进程</Checkbox>
        </FormItem>
        <FormItem label="被注入进程">
          <Select style="width:160px;">
            <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <Input style="width:340px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
        </FormItem>
        <FormItem label="匹配子进程级数" v-if="matchProc && action != 2">
          <InputNumber style="width:380px;" :class="{ error: childNumEro }" v-model="childNum"
            placeholder="1~65534代表父进程的第几个子进程" />
        </FormItem>
      </Form>
      <Form :label-width="120" v-if="type == 9">
        <FormItem label="枚举窗口进程">
          <Select style="width:160px;">
            <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <Input style="width:340px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
          <Checkbox border class="checkBg" v-if="action != 2">匹配子进程</Checkbox>
        </FormItem>
        <FormItem label="被枚举窗口进程">
          <Select style="width:160px;">
            <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <Input style="width:340px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
        </FormItem>
        <FormItem label="匹配子进程级数" v-if="matchProc && action != 2">
          <InputNumber style="width:380px;" :class="{ error: childNumEro }" v-model="childNum"
            placeholder="1~65534代表父进程的第几个子进程" />
        </FormItem>
      </Form>
      <Form :label-width="120" v-if="type == 11">
        <FormItem label="破坏者进程">
          <Select style="width:160px;">
            <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <Input style="width:340px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
          <Checkbox border class="checkBg" v-if="action != 2">匹配子进程</Checkbox>
        </FormItem>
        <FormItem label="被保护进程">
          <Select style="width:160px;">
            <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <Input style="width:340px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
        </FormItem>
        <FormItem label="匹配子进程级数" v-if="matchProc && action != 2">
          <InputNumber style="width:380px;" :class="{ error: childNumEro }" v-model="childNum"
            placeholder="1~65534代表父进程的第几个子进程" />
        </FormItem>
        <FormItem label="保护权限">
          <CheckboxGroup>
            <Checkbox>结束进程</Checkbox>
            <Checkbox>挂起进程</Checkbox>
            <Checkbox>创建远线程</Checkbox>
            <Checkbox>写入内存</Checkbox>
            <Checkbox>读取内存</Checkbox>
          </CheckboxGroup>
        </FormItem>
      </Form>
      <Form :label-width="120" v-if="type == 12">
        <FormItem label="枚举进程">
          <Select style="width:160px;">
            <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <Input style="width:340px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
          <Checkbox border class="checkBg">匹配子进程</Checkbox>
        </FormItem>
        <FormItem label="被枚举进程">
          <Select style="width:160px;">
            <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <Input style="width:340px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
        </FormItem>
        <FormItem label="匹配子进程级数" v-if="matchProc">
          <InputNumber style="width:380px;" :class="{ error: childNumEro }" v-model="childNum"
            placeholder="1~65534代表父进程的第几个子进程" />
        </FormItem>
      </Form>
      <Form :label-width="120"  v-if="(type == 14)">
        <FormItem label="发起方">
          <Select style="width:160px;" v-model="parentProVal">
            <Option v-for="(item, index) in perPoress" :value="item.value" :key="index">{{ item.label }}</Option>
          </Select>
          <Input v-if="parentProVal != 'null'" v-model="parentVal" class="margin6" :class="{ error: parentError }"
            style="width:340px;margin-left: -1px;" :placeholder="parentPsw"></Input>
          <!-- <Checkbox border class="checkBg " v-model="matchProc" v-if="action != 2">匹配子进程</Checkbox> -->
        </FormItem>
        <FormItem label="目标方">
          <Select style="width:160px;" v-model="childProVal">
            <Option v-for="(item, index) in perPoress" v-if="(index !=0)" :value="item.value" :key="index">{{
                item.label
            }}</Option>
          </Select>
          <Input  v-if="childProVal != 'null'" style="width:340px;margin-left: -1px;" :class="{ error: childrenError }" v-model="childVal"
            :placeholder="childPsw"></Input>
        </FormItem>
      </Form>
      <Form :label-width="120">
        <FormItem label="处理方式">
          <Select style="width:210px;" v-model="action">
            <template v-if="type == 1">
              <template v-for="item in treatmentFile">

                <Option :value="item.value" :key="item.value"
                  :disabled="(item.value == 3 && parentProVal == 'Sign') || (item.value == 3 && parentProVal == 'SignName') || (item.value == 4 && parentProVal =='MD5')|| (item.value == 4 && parentProVal =='Hash')|| (item.value == 4 && parentProVal =='Sign')|| (item.value == 4 && parentProVal =='SignName')">
                  <template v-if="item.label == '拦截'">
                    {{ typeName }}
                  </template>
                  <template v-else>
                    {{
                        item.label
                    }}
                  </template>
                  <b v-if="(item.value == 3 && parentProVal == 'Sign') || (item.value == 3 && parentProVal == 'SignName')"
                    class="f12 ">(该功能开发中)</b>
                </Option>
              </template>
            </template>
            <template v-else-if="type == 4">
              <Option v-for="(item) in regisList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </template>
            <template v-else-if="type == 8">
              <Option v-for="(item) in windowAction" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </template>
            <template v-else-if="type == 6">
              <Option value="Remove">移除</Option>
            </template>
            <template v-else-if="type == 13">
              <template v-if="threadType ==2">
                <Option v-for="(item) in threadList2" :value="item.value" :disabled="item.disabled" :key="item.value">{{
                    item.label
                }}</Option>
              </template>
              <template v-else>
                <Option v-for="(item) in threadList" :value="item.value" :key="item.value">{{ item.label }}
                </Option>
              </template>

            </template>
            <template v-else-if="(type == 0)">
              <Option v-for="(item) in processAction" :value="item.value" :disabled="item.disabled" :key="item.value">{{
                    item.label
                }}</Option>
            </template>
            <template v-else-if="(type == 14)">
              <Option v-for="(item) in proTectAction" :value="item.value" :disabled="item.disabled" :key="item.value">{{
                    item.label
                }}</Option>
            </template>
            <template v-else>
              <Option v-for="(item) in treatment" v-show="item.value != 3" :value="item.value" :key="item.value">
                <template v-if="item.label == '拦截'">
                  {{ typeName }}
                </template>
                <template v-else>
                  {{
                      item.label
                  }}
                </template>
              </Option>
            </template>
          </Select>
          <template v-if="type != 3">
            <span style="margin-left:10px;" v-if="action == 2" class="errorCol">* <i
                v-if="type == 0">白名单模式下，父</i>进程不能为任意进程</span>
          </template>
        </FormItem>
        <p class="errorCol" style="padding-left:120px;padding-bottom:10px;">{{ errorMsg }}</p>
        <FormItem label="">
          <a href="#" class="blue-btn" @click="saveFn">添加</a>
        </FormItem>
      </Form>
    </div>
  </div>
</template>
<script>
import processCom from './processCom.vue'
import fileCom from './file.vue'
import networkCom from './network.vue'
import modelCom from './model.vue'
import registryCom from './registry.vue'
import driveCom from './drive.vue'
import driveReturnCom from './driveReturn.vue'
import injectionPro from './injectionPro.vue'
import windowCom from './windowCom.vue'
import windowReCom from './windowReCom.vue'
import processPro from './processPro.vue'
import processHide from './processHide.vue'
import editorCom from './editorCom.vue'
import ruleResult from '../../utils/rule.js'
export default {
  components: {
    processCom,
    fileCom,
    modelCom,
    networkCom,
    registryCom,
    driveCom,
    driveReturnCom,
    injectionPro,
    windowCom,
    windowReCom,
    processPro,
    processHide,
    editorCom
  },
  data () {
    return {
      title: '新增',
      threadType: '1',
      data: [
        {
          title: '进程',
          id: 0,
        },

        {
          title: '驱动',
          id: 5
        },
        {
          title: '模块(DLL)',
          id: 2
        },
        {
          title: '文件',
          id: 1,
        },
        {
          title: '注册表',
          id: 4
        },
        {
          title: '网络',
          id: 3
        },
        {
          title: '驱动回调',
          id: 6,
        },
        // {
        //   title: '注入保护',
        //   id: 7
        // },
        {
          title: '窗口',
          id: 8
        },
        {
          title: '线程',
          id: 13
        },
        {
          title: '注入',
          id: 14
        }
        // {
        //   title: '窗口枚举',
        //   id: 9
        // },
        // {
        //   title: '插件',
        //   id: 10
        // },
        // {
        //   title: '进程保护',
        //   id: 11
        // },
        // {
        //   title: '进程隐藏',
        //   id: 12
        // }
      ],
      callBackList: [
        {
          label: '进程回调',
          value: 'Process'
        },
        {
          label: '镜像回调',
          value: 'Image'
        },
        {
          label: '线程回调',
          value: 'Thread'
        },
        {
          label: '注册表回调',
          value: 'Reg'
        }
      ],
      type: '0',
      formItem: {
        input: ''
      },
      driveList2: [

        {
          label: '模块名称',
          value: 'Name'
        },
        {
          label: '模块路径',
          value: 'Path'
        },
        {
          label: '文件特征码(Hash)',
          value: 'Hash'
        },
        {
          label: '文件MD5',
          value: 'MD5'
        },
        {
          label: '文件数字签名序列号',
          value: 'Sign'
        },
        {
          label: '文件数字签名公司名',
          value: 'SignName'
        }
      ],
      driveList: [

        {
          label: '驱动名称',
          value: 'Name'
        },
        {
          label: '驱动路径',
          value: 'Path'
        },
        {
          label: '文件特征码(Hash)',
          value: 'Hash'
        },
        {
          label: '文件MD5',
          value: 'MD5'
        },
        {
          label: '文件数字签名序列号',
          value: 'Sign'
        },
        {
          label: '文件数字签名公司名',
          value: 'SignName'
        }
      ],
      registerList: [
        {
          label: '注册表路径'
        },
        {
          label: '注册表名称'
        }
      ],
      tagetList: [
        {
          value: 'IP',
          label: 'IP端口'
        },
        // {
        //   value: 'Real',
        //   label: '域名'
        // },
        // {
        //   value: 'HTTP',
        //   label: 'HTTP'
        // }
      ],
      threadList2: [
        {
          label: '挂起父线程',
          value: 'suspend_creator',
          disabled: true
        },
        {
          label: '挂起子线程',
          value: 'suspend_target'
        },
        {
          label: '挂起父子进程',
          value: 'suspend_target|suspend_creator',
          disabled: true
        },
        {
          label: '结束父线程',
          value: 'kill_creator',
          disabled: true
        },
        {
          label: '结束子线程',
          value: 'kill_target'
        },
        {
          label: '结束父子线程',
          value: 'kill_creator|kill_target',
          disabled: true
        },
        {
          label: '阻止线程运行',
          value: 'patch_target'
        },
        {
          label: '丢弃父线程',
          value: 'drop_creator',
          disabled: true
        },
        {
          label: '丢弃子线程',
          value: 'drop_target',
          disabled: true
        }, {
          label: '丢弃父子线程',
          value: 'drop_creator|drop_target',
          disabled: true
        },
      ],
      threadList: [
        {
          label: '挂起父线程',
          value: 'suspend_creator',
          disabled: false
        },
        {
          label: '挂起子线程',
          value: 'suspend_target',
          disabled: false
        },
        {
          label: '挂起父子进程',
          value: 'suspend_target|suspend_creator',
          disabled: false
        },
        {
          label: '结束父线程',
          value: 'kill_creator',
          disabled: false
        },
        {
          label: '结束子线程',
          value: 'kill_target',
          disabled: false
        },
        {
          label: '结束父子线程',
          value: 'kill_creator|kill_target',
          disabled: false
        },
        {
          label: '阻止线程运行',
          value: 'patch_target',
          disabled: false
        },
        {
          label: '丢弃父线程',
          value: 'drop_creator',
          disabled: false
        },
        {
          label: '丢弃子线程',
          value: 'drop_target',
          disabled: false
        }, {
          label: '丢弃父子线程',
          value: 'drop_creator|drop_target',
          disabled: false
        },
      ],
      modelList: [
        {
          label: '模块名字'
        },
        {
          label: '模块路径'
        },
        {
          label: '模块文件特征码'
        },
        {
          label: '模块签名序列号'
        },
        {
          label: '模块签名名字'
        }
      ],
      fileList: [
        {
          label: '文件名字',
          value: 'Name'
        },
        {
          label: '文件路径',
          value: 'Path'
        }

      ],
      fileActionList: [
        {
          'value': 'Create',
          'label': '文件新建',
        },
        {
          'value': 'Open',
          'label': '文件打开',
        },
        {
          'value': 'Read',
          'label': '文件读取',
        },
        {
          'value': 'Write',
          'label': '文件写入',
        },
        {
          'value': 'Delete',
          'label': '文件删除',
        },
        {
          'value': 'Rename',
          'label': '文件重命名',
        },

      ],
      regActionList: [
        {
          'value': 'Create',
          'label': '创建项',
        },
        {
          'value': 'Read',
          'label': '读取项',
        },
        {
          'value': 'Write',
          'label': '写项及键值',
        },
        {
          'value': 'Deletekey',
          'label': '删除项',
        },
        // {
        //   'value': 'Deletevalue',
        //   'label': '删除键值',
        // }
      ],
      windowAction: [
        {
          label: '关闭窗口',
          value: 'closewnd'
        },
        {
          label: '隐藏窗口',
          value: 'hidewnd'
        },
        {
          label: '最小化窗口',
          value: 'minwnd'
        },
        {
          label: '移动窗口到屏幕外',
          value: 'outscreen'
        },
        {
          label: '结束进程',
          value: 'endproc'
        },
      ],
      regList: [
        {
          label: '任意位置',
          value: 'null'
        },
        {
          label: '注册表路径',
          value: 'Name'
        },
      ],
      processAction: [
        {
          label: '拦截进程启动',
          value: 1
        },
        {
          label: '仅放行（白名单）',
          value: 2
        },
        // {
        //   label: '拦截进程注入',
        //   value: 3
        // },
        // {
        //   label: '注入检测',
        //   value: 4
        // }
      ],
      treatmentFile: [
        {
          label: '拦截',
          value: 1
        },
        {
          label: '仅放行（白名单）',
          value: 2
        },
        {
          label: '挂起发起文件操作的线程',
          value: 3
        },
        {
          label: '隐藏文件（仅支持路径）',
          value: 4
        },
      ],
      treatment5: [
        {
          label: '拦截',
          value: 1,
        },
        {
          label: '拦截并结束当前父进程',
          value: 2,
        },
        {
          label: '拦截并挂起当前父进程',
          value: 3,
        },
        {
          label: '拦截并结束线程',
          value: 4,
        },
        {
          label: '拦截并挂起线程',
          value: 5,
        },
        {
          label: '拦截并挂起进程',
          value: 6,
        },
        {
          label: '拦截并结束进程',
          value: 7,
        },
        {
          label: '仅放行（白名单）',
          value: 8,
        },
      ],
      treatment: [
        {
          label: '拦截',
          value: 1
        },
        {
          label: '仅放行（白名单）',
          value: 2
        },
        {
          label: '挂起发起文件操作的线程',
          value: 3
        },
      ],
      regisList: [
        {
          label: '拦截已选“注册表权限”',
          value: 1
        },
      ],
      callList: [
        {
          label: '驱动名称',
          value: 'Name'
        },
        {
          label: 'MD5码',
          value: 'MD5'
        },
        {
          label: '特征码（Hash）',
          value: 'Hash'
        },
        {
          label: '文件数字签名序列号',
          value: 'Sign'
        },
        {
          label: '文件数字签名公司名',
          value: 'SignName'
        }
      ],
      perPoress: [
        {
          label: '任意进程',
          value: 'null'
        },
        {
          label: '进程名称',
          value: 'Name'
        },
        {
          label: '进程路径',
          value: 'Path'
        },
        {
          label: '进程MD5码',
          value: 'MD5'
        },
        {
          label: '文件特征码（Hash）',
          value: 'Hash'
        },
        {
          label: '文件数字签名序列号',
          value: 'Sign'
        },
        {
          label: '文件数字签名公司名',
          value: 'SignName'
        }
        // {
        //   label: '进程签名序列号',
        //   value: 'Sign'
        // },
        // {
        //   label: '进程签名名字',
        //   value: 'signName'
        // }
      ],
      perPoressLine: [
        {
          label: '任意进程',
          value: 'null'
        },
        {
          label: '进程名称',
          value: 'Name'
        },
        {
          label: '进程路径',
          value: 'Path'
        },
        {
          label: '进程MD5码',
          value: 'MD5'
        },
        {
          label: '文件特征码（Hash）',
          value: 'Hash'
        },
        {
          label: '文件数字签名序列号',
          value: 'Sign'
        },
        {
          label: '文件数字签名公司名',
          value: 'SignName'
        },
        {
          label: '进程命令行',
          value: 'cmdline'
        }
      ],
      parentProVal: 'Name',
      parentVal: '',
      childProVal: 'Name',
      childVal: '',
      action: 1,
      fileAction: [],
      ipVal: '',
      portVal: '',
      calss: '',
      width: '',
      height: '',
      yVal: '',
      xVal: '',
      style: '',
      style1: '',
      errorMsg: '',
      parentPsw: '支持进程名称，通配符*和?，以及null',
      childPsw: '支持进程名称，通配符*和?，以及null',
      matchProc: false,
      childNum: '',
      parentError: false,
      childrenError: false,
      childNumEro: false,
      actionEro: true,
      portError: false,
      childrenError2: false,
      childrenError3: false,
      childrenError4: false,
      childrenError5: false,
      childrenError6: false,
      Delay: 1000,
      Offset: '',
      index: '',
      isDelay: false,
      typeName: '拦截进程启动',
      proTectAction: [
        {
          label: '拦截注入',
          value: 'block'
        },
      ]
    }
  },
  watch: {
    parentProVal () {
      this.passWord(this.parentProVal, 1)
    },
    childProVal () {
      this.passWord(this.childProVal, 2)
    },
    index () {
      if (this.type == 13) {
        if (this.index > 0) {
          this.action = 'suspend_target'
        } else {
          this.action = 'suspend_creator'
        }
      }
    },
    action() {
      if (this.action == 'patch_target') {
        this.threadType = '1'
      }
    },
    type () {
      this.passWord(this.childProVal, 1)
      this.passWord(this.childProVal, 2)
      // let index = this.data.findIndex(val => val.id == this.type)
      // this.typeName = this.data[index].title
      if (this.type == 0) {
        this.typeName = '拦截进程启动'
      } else if (this.type == 5) {
        this.typeName = '拦截驱动加载'
      } else if (this.type == 2) {
        this.typeName = '拦截DLL加载'
      } else if (this.type == 1) {
        this.typeName = '拦截已选“文件权限”'
      } else if (this.type == 3) {
        this.typeName = '拦截使用已选协议发送数据'
      }
    }
  },
  methods: {
    passWord (type, key) {
      switch (type) {
        case 'null':
          if (key == 1) {
            this.parentPsw = ''
          } else {
            this.childPsw = ''
          }
          break
        case 'Name':
          if (key == 1) {
            if (this.type == 5 || this.type == 2) {
              this.parentPsw = '支持模块名称，通配符*和?，以及null'
            } else if (this.type == 13 || this.type == 6) {
              this.parentPsw = '支持驱动名称，通配符*和?，以及null'
            } else if (this.type == 1) {
              this.parentPsw = '支持文件名称，通配符*和?，以及null'
            } else if (this.type == 4) {
              this.parentPsw = '支持以\\开头且以*或\\结尾的进程路径，通配符*和?，以及null'
            } else {
              this.parentPsw = '支持进程名称，通配符*和?，以及null'
            }
          } else {
            if (this.type == 5 || this.type == 2) {
              this.childPsw = '支持模块名称，通配符*和?，以及null'
            } else if (this.type == 13 || this.type == 6) {
              this.childPsw = '支持驱动名称，通配符*和?，以及null'
            } else if (this.type == 1) {
              this.childPsw = '支持文件名称，通配符*和?，以及null'
            } else if (this.type == 4) {
              this.childPsw = '支持以\\开头且以*或\\结尾的进程路径，通配符*和?，以及null'
            } else {
              this.childPsw = '支持进程名称，通配符*和?，以及null'
            }
          }
          break
        case 'Path':
          if (key == 1) {
            this.parentPsw = '支持以\\开头且以*或\\结尾的进程路径，通配符*和?，以及null'
          } else {
            this.childPsw = '支持以\\开头且以*或\\结尾的进程路径，通配符*和?，以及null'
          }
          break
        case 'MD5':
          if (key == 1) {
            this.parentPsw = '支持32位大小写字母数字，不支持通配符'
          } else {
            this.childPsw = '支持32位大小写字母数字，不支持通配符'
          }
          break
        case 'Hash':
          if (key == 1) {
            this.parentPsw = '8位大小写字母数字，不支持通配符'
          } else {
            this.childPsw = '8位大小写字母数字，不支持通配符'
          }
          break
        case 'Sign':
          if (key == 1) {
            this.parentPsw = '20位或32位或38位大小写字母数字，不支持通配符和空格'
          } else {
            this.childPsw = '20位或32位或38位大小写字母数字，不支持通配符和空格'
          }
          break
        case 'SignName':
          if (key == 1) {
            this.parentPsw = '最大64位字符及除了通配符*和?之外的所有字符'
          } else {
            this.childPsw = '最大64位字符及除了通配符*和?之外的所有字符'
          }
          break
        case 'cmdline':
          this.parentPsw = '请输入命令行文本'
          break
        default:
          break
      }
    },
    resetFn () {
      this.parentProVal = 'Name'
      this.parentVal = ''
      this.childProVal = 'Name'
      this.childVal = ''
      this.action = 1
      console.log(this.type)
      if (this.type == 6) {
        this.action = 'Remove'
        this.childProVal = 'Process'
      } else if (this.type == 8) {
        this.action = 'closewnd'
      } else if (this.type == 13) {
        if (this.index > 0) {
          this.action = 'suspend_target'
        } else {
          this.action = 'suspend_creator'
        }
      } else if (this.type == 14) {
        this.action = 'block'
      }
      if (this.type == 13) {
        this.matchProc = true
      } else {
        this.matchProc = false
      }
      this.fileAction = []
      this.ipVal = ''
      this.portVal = ''
      this.title = ''
      this.calss = ''
      this.width = ''
      this.height = ''
      this.yVal = ''
      this.xVal = ''
      this.style = ''
      this.style1 = ''
      this.errorMsg = ''
      this.childNum = ''
      this.parentError = false
      this.childrenError = false
      this.childNumEro = false
      this.portError = false
      this.childrenError2 = false
      this.childrenError3 = false
      this.childrenError4 = false
      this.childrenError5 = false
      this.childrenError6 = false
      this.Delay = 1000
      this.Offset = ''
      this.index = ''
      this.isDelay = false
    },
    erroInit () {
      this.errorMsg = ''
      this.parentError = false
      this.childrenError = false
      this.childNumEro = false
      this.portError = false
      this.childrenError2 = false
      this.childrenError3 = false
      this.childrenError4 = false
      this.childrenError5 = false
      this.childrenError6 = false
    },
    editorFn (val) {
      (this).$refs.editorCom.visible = true
    },
    change (val) {
      console.log(val)
    },
    selectFn (val) {
      this.type = val.id
      this.resetFn()
      this.fileAction = []
      if (this.type == 4) {
        this.fileAction = ['Create', 'Read', 'Write', 'Deletekey']
      }
      if (this.type == 3) {
        this.fileAction = ['TCP', 'UDP', 'ICMP']
      }
      if (this.type == 1) {
        this.fileAction = ['Create', 'Open', 'Read', 'Write', 'Delete', 'Rename']
      }
    },
    saveFn () {
      if (this.type == 0) {
        selfPath2 = '*\\*.exe'
      }
      var parentPath, selfPath, val, selfPath2
      if (this.type == 0) {
        selfPath2 = '*\\*.exe'
      } else {
        selfPath2 = '*.txt'
      }
      if (this.parentProVal == 'null') {
        parentPath = null
      } else {
        if (this.parentProVal == 'Name') {
          if (this.type == 6) {
            if (this.$validateCenter.isHashLine(this.parentVal)) {
              parentPath = this.parentProVal + '=' + '"' + this.parentVal + '"'
            } else {
              parentPath = this.parentProVal + '=' + '"' + '*\\' + this.parentVal + '"'
            }
          } else {
            if (this.$validateCenter.isHashLine(this.parentVal)) {
              parentPath = 'Path=' + '"' + this.parentVal + '"'
            } else {
              if (this.$validateCenter.isRouteHas(this.parentVal)) {
                parentPath = 'Path=' + '"' + this.parentVal + '"'
              } else {
                parentPath = 'Path=' + '"' + '*\\' + this.parentVal + '"'
              }
            }
          }
        } else if (this.parentProVal == 'Path') {
          if (this.$validateCenter.isRouteHas(this.parentVal)) {
            parentPath = this.parentProVal + '=' + '"' + this.parentVal + '"'
          } else {
            parentPath = this.parentProVal + '=' + '"' + '*' + this.parentVal + '"'
          }
        } else if (this.parentProVal == 'SignName') {
          parentPath = 'Sign=' + '"' + this.parentVal + '"'
        } else {
          parentPath = this.parentProVal + '=' + '"' + this.parentVal + '"'
        }
      }

      if (this.childProVal != '' && this.childVal != '') {
        if (this.childProVal == 'Name') {
          if (this.type == 4) {
            selfPath = this.$validateCenter.reginCheck(this.childVal)
          } else if (this.type == 13 && this.childVal == 'null') {
            selfPath = null
          } else {
            if (this.$validateCenter.isHashLine(this.childVal)) {
              selfPath = 'Path=' + '"' + this.childVal + '"'
            } else {
              if (this.$validateCenter.isRouteHas(this.childVal)) {
                selfPath = 'Path=' + '"' + this.childVal + '"'
              } else {
                selfPath = 'Path=' + '"' + '*\\' + this.childVal + '"'
              }
            }
          }
          if (this.action == 2) {
            if (this.childVal.indexOf('\\') != -1) {
              if (this.$validateCenter.lastIndexOf(this.childVal, '.') != -1) {
                let key = this.$validateCenter.lastIndexOf(this.childVal, '.')
                let key2 = this.$validateCenter.lastIndexOf(this.childVal, '\\')
                let msg = this.$validateCenter.replacepos(this.childVal, key2 + 1, key, '*')
                selfPath2 = '*' + msg
              } else {
                if (this.$validateCenter.isRouteHas(this.childVal)) {
                  selfPath2 = this.childVal
                } else {
                  selfPath2 = '*'
                }
              }
            } else {
              if (this.$validateCenter.lastIndexOf(this.childVal, '.') != -1) {
                let key = this.$validateCenter.lastIndexOf(this.childVal, '.')
                let msg = this.$validateCenter.replacepos(this.childVal, 0, key, '*')
                selfPath2 = msg
              } else {
                if (this.$validateCenter.isRouteHas(this.childVal)) {
                  selfPath2 = this.childVal
                } else {
                  selfPath2 = '*'
                }
              }
            }
          }
        } else if (this.childProVal == 'Path') {
          if (this.type == 13 && this.childVal == null) {
            selfPath = null
          } else {
            if (this.$validateCenter.isRouteHas(this.childVal)) {
              selfPath = 'Path=' + '"' + this.childVal + '"'
            } else {
              selfPath = 'Path=' + '"' + '*' + this.childVal + '"'
            }
          }
          if (this.action == 2) {
            if (this.childVal.indexOf('\\') != -1) {
              if (this.$validateCenter.lastIndexOf(this.childVal, '.') != -1) {
                let key = this.$validateCenter.lastIndexOf(this.childVal, '.')
                let key2 = this.$validateCenter.lastIndexOf(this.childVal, '\\')
                let msg = this.$validateCenter.replacepos(this.childVal, key2 + 1, key, '*')
                selfPath2 = '*' + msg
              } else {
                if (this.$validateCenter.isRouteHas(this.childVal)) {
                  selfPath2 = this.childVal
                } else {
                  selfPath2 = '*'
                }
              }
            } else {
              if (this.$validateCenter.lastIndexOf(this.childVal, '.') != -1) {
                let key = this.$validateCenter.lastIndexOf(this.childVal, '.')
                let msg = this.$validateCenter.replacepos(this.childVal, 0, key, '*')
                selfPath2 = msg
              } else {
                if (this.$validateCenter.isRouteHas(this.childVal)) {
                  selfPath2 = this.childVal
                } else {
                  selfPath2 = '*'
                }
              }
            }
          }
        } else if (this.childProVal == 'SignName') {
          selfPath = 'Sign=' + '"' + this.childVal + '"'
        } else {
          selfPath = this.childProVal + '=' + '"' + this.childVal + '"'
        }
      } else if (this.childProVal == 'null') {
        selfPath = 'null'
      }
      if (this.matchProc) {
        if (this.parentProVal == 'null' || this.parentProVal.indexOf('*.') != -1) {
          this.errorMsg = '使用匹配层级模式时，父进程不可为任意进程（*.exe）或null'
          this.parentError = true
          return
        }
        if (this.childNum != '') {
          if (this.childNum < 0 || this.childNum > 65534) {
            this.errorMsg = '匹配子进程级数不正确'
            return
          }
        } else {
          this.childNum = 0
        }
      }
      switch (Number(this.type)) {
        case 0:
          if (this.parentProVal == '') {
            this.errorMsg = '请选择父进程类型'
            return
          } else {
            if (this.parentProVal != 'null') {
              // this.errorMsg = '请输入进程信息'
              let msg = this.$validateCenter.checkPro(this.parentProVal, this.parentVal)
              if (msg != '') {
                this.erroInit()
                this.errorMsg = msg
                this.parentError = true
                return
              }
            }
          }
          if (this.action == 2 && this.parentProVal == 'null') {
            this.errorMsg = '父进程不能为任意进程'
            return
          }
          let msg2 = this.$validateCenter.checkPro(this.childProVal, this.childVal)
          if (msg2 != '') {
            this.erroInit()
            this.errorMsg = msg2
            this.childrenError = true
            return
          }
          if (this.action == '') {
            this.errorMsg = '请选择处理方式'
            return
          }
          if (this.action == 1) {
            val = ruleResult.procStartFn(parentPath, selfPath, 'Deny', this.matchProc, this.childNum)
          } else if (this.action == 2) {
            val = ruleResult.procStartOneFn(parentPath, selfPath, this.matchProc, this.childNum, selfPath2)
          }
          this.$emit('addRule', val)
          this.erroInit()
          break
        case 13:
          if (this.parentProVal == '') {
            this.erroInit()
            this.errorMsg = '请选择进程类型'
            return
          } else {
            if (this.parentProVal != 'null') {
              // this.errorMsg = '请输入进程信息'
              let msg = this.$validateCenter.checkPro(this.parentProVal, this.parentVal)
              if (msg != '') {
                this.erroInit()
                this.errorMsg = msg
                this.parentError = true
                return
              } else {

              }
            }
          }
          let msg4 = this.$validateCenter.checkPro(this.childProVal, this.childVal)
          if (msg4 != '') {
            this.erroInit()
            this.errorMsg = msg4
            this.childrenError = true
            return
          }
          let offset
          if (this.isDelay) {
            if (!this.Delay > 0) {
              this.errorMsg = '延时最小值为1'
              return
            }
          }
          if (this.index == '' || this.index == null) {
            this.index = 0
          }
          if (this.Offset == '' || this.Offset == null || this.Offset == 0) {
            offset = 0
          } else {
            this.index = 0
            offset = this.Offset
          }
          if (this.action == '') {
            this.erroInit()
            this.errorMsg = '请选择处理方式'
            return
          }
          if (this.parentProVal == 'cmdline') {
            if (offset == 0 && this.index == 0) {
              this.erroInit()
              this.errorMsg = '在进程为命令行模式下，偏移量或者线程序号必须得有个值,且不能都为0'
              return
            }
          }
          let val = ruleResult.ThreadControl(parentPath, selfPath, this.Delay, offset, this.action, this.index, this.matchProc, this.childNum)
          this.$emit('addRule', val)
          this.erroInit()
          break
        case 5:
          if (this.parentProVal == '') {
            this.erroInit()
            this.errorMsg = '请选择进程类型'
            this.parentError = true
            return
          } else {
            if (this.parentProVal != 'null') {
              // this.errorMsg = '请输入进程信息'
              let msg = this.$validateCenter.checkPro(this.parentProVal, this.parentVal)
              if (msg != '') {
                this.erroInit()
                this.errorMsg = msg
                this.parentError = true
                return
              }
            }
          }
          let msg = this.$validateCenter.checkPro(this.childProVal, this.childVal)
          if (msg != '') {
            this.erroInit()
            this.errorMsg = msg
            this.childrenError = true
            return
          }
          // if (this.childVal == '')
          // {
          //   this.errorMsg = '请填写驱动的值'
          //   return
          // }
          if (this.action == '') {
            this.erroInit()
            this.errorMsg = '请选择处理方式'
            return
          }
          if (this.action == 1) {
            val = ruleResult.Module(parentPath, selfPath, this.matchProc, this.childNum)
          } else {
            val = ruleResult.ModuleOne2(parentPath, selfPath, this.matchProc, this.childNum, selfPath2)
          }
          this.$emit('addRule', val)
          this.erroInit()
          break
        case 2:
          if (this.parentProVal == '') {
            this.erroInit()
            this.errorMsg = '请选择进程类型'
            return
          } else {
            if (this.parentProVal != 'null') {
              // this.errorMsg = '请输入进程信息'
              let msg = this.$validateCenter.checkPro(this.parentProVal, this.parentVal)
              if (msg != '') {
                this.erroInit()
                this.errorMsg = msg
                this.parentError = true
                return
              }
            }
          }
          let msg3 = this.$validateCenter.checkPro(this.childProVal, this.childVal)
          if (msg3 != '') {
            this.erroInit()
            this.errorMsg = msg3
            this.childrenError = true
            return
          }
          // if (this.childVal == '')
          // {
          //   this.errorMsg = '请填写模块的值'
          //   return
          // }
          if (this.action == '') {
            this.erroInit()
            this.errorMsg = '请选择处理方式'
            return
          }
          if (this.action == 1) {
            val = ruleResult.Module(parentPath, selfPath, this.matchProc, this.childNum)
          } else {
            val = ruleResult.ModuleOne(parentPath, selfPath, this.matchProc, this.childNum, selfPath2)
          }
          this.$emit('addRule', val)
          this.erroInit()

          break
        case 1:
          if (this.parentProVal == '') {
            this.erroInit()
            this.errorMsg = '请选择进程类型'
            return
          } else {
            if (this.parentProVal != 'null') {
              // this.errorMsg = '请输入进程信息'
              let msg = this.$validateCenter.checkPro(this.parentProVal, this.parentVal)
              if (msg != '') {
                this.erroInit()
                this.errorMsg = msg
                this.parentError = true
                return
              }
            }
          }
          let msg22 = this.$validateCenter.checkPro(this.childProVal, this.childVal)
          if (msg22 != '') {
            this.erroInit()
            this.errorMsg = msg22
            this.childrenError = true
            return
          }
          if (this.fileAction == '') {
            this.erroInit()
            this.errorMsg = '请至少选择一种文件操作权限'
            return
          }
          if (this.action == '') {
            this.erroInit()
            this.errorMsg = '请选择处理方式'
            return
          }
          if (this.action == 1) {
            val = ruleResult.FileCheck(selfPath, parentPath, this.fileAction.join(';'), this.matchProc, this.childNum)
          } else if (this.action == 2) {
            val = ruleResult.FileCheckOne(selfPath, parentPath, this.fileAction.join(';'), this.matchProc, this.childNum, selfPath2)
          } else if (this.action == 3) {
            if (this.parentProVal == 'Sign' || this.parentProVal == 'SignName') {
              this.erroInit()
              this.errorMsg = '挂起线程不支持添加文件数字签名序列号或文件数字签名公司名'
              this.parentError = true
              return
            }
            val = ruleResult.ThreadFileCheck(selfPath, parentPath, this.fileAction.join(';'), this.matchProc, this.childNum)
          } else {
            if (this.parentProVal != 'Path' && this.parentProVal != 'Name') {
              this.erroInit()
              this.errorMsg = '隐藏文件仅支持路径'
              this.parentError = true
              return
            }
            val = ruleResult.SpecFileHide(selfPath, parentPath)
          }
          this.$emit('addRule', val)
          this.erroInit()
          break
        case 4:
          if (this.parentProVal == '') {
            this.erroInit()
            this.errorMsg = '请选择进程类型'
            return
          } else {
            if (this.parentProVal != 'null') {
              // this.errorMsg = '请输入进程信息'
              let msg = this.$validateCenter.checkPro(this.parentProVal, this.parentVal)
              if (msg != '') {
                this.erroInit()
                this.errorMsg = msg
                this.parentError = true
                return
              }
            }
          }
          if (this.childVal == '' && this.childProVal != 'null') {
            this.erroInit()
            this.errorMsg = '请填写键值路径的信息'
            this.childrenError = true
            return
          }
          if (this.parentProVal == 'null' && this.childProVal == 'null') {
            this.erroInit()
            this.errorMsg = '键值路径与进程不能同时为任意值,请修改'
            this.childrenError = true
            return
          }
          if (this.childProVal == 'null') {
            selfPath = 'null'
          }
          if (this.fileAction == '') {
            this.errorMsg = '请至少选择一项注册表权限'
            return
          }
          if (this.action == '') {
            this.errorMsg = '请选择处理方式'
            return
          }
          if (this.action == 1) {
            // let val2 = ''
            // if (this.childProVal == null)
            // {
            //   val2 = null
            // } else
            // {
            //   if (this.childVal == '')
            //   {
            //     val2 = 'null'
            //   } else
            //   {
            //     val2 = `'${this.childVal}'`

            //   }
            // }
            if (this.fileAction.length == this.regActionList.length) {
              val = ruleResult.RegCheck(selfPath, parentPath, 'All', this.matchProc, this.childNum)
              this.$emit('addRule', val)
              this.erroInit()
            } else {
              this.fileAction.forEach(el => {
                val = ruleResult.RegCheck(selfPath, parentPath, el, this.matchProc, this.childNum)
                this.$emit('addRule', val)
                this.erroInit()
              })
            }
          }
          break
        case 3:
          if (this.parentProVal == '') {
            this.errorMsg = '请选择进程类型'
            return
          } else {
            if (this.parentProVal != 'null') {
              let msg = this.$validateCenter.checkPro(this.parentProVal, this.parentVal)
              if (msg != '') {
                this.erroInit()
                this.errorMsg = msg
                this.parentError = true
                return
              }
            }
          }
          if (this.parentProVal == 'null') {
            if (this.ipVal == '' || this.ipVal == 'null') {
              this.erroInit()
              this.errorMsg = '进程与目标地址不能同时为null或空'
              this.childrenError = true
              return
            } else {
              if (this.childProVal == 'IP') {
                if (this.ipVal.length == 0 || this.ipVal.length > 15) {
                  this.erroInit()
                  this.errorMsg = '格式错误'
                  this.childrenError = true
                  return
                }
                if (/[^\0-9\.\*\?]/g.test(this.ipVal)) {
                  this.erroInit()
                  this.errorMsg = '格式错误'
                  this.childrenError = true
                  return
                }
              }
            }
          }
          if (this.ipVal == 'null') {
            this.erroInit()
            this.errorMsg = '仅支持半角数字、小数点及通配符*和?'
            this.childrenError = true
            return
          }
          if (this.portVal != '') {
            if (/[^\0-9\*\?]/g.test(this.portVal)) {
              this.erroInit()
              this.errorMsg = '仅支持半角数字及通配符*和?'
              this.portError = true
              return
            } else {
              console.log(23)
            }
          }
          if (this.fileAction.length == 0) {
            this.erroInit()
            this.errorMsg = '请选择协议支持类型'
            return
          }
          if (this.action == '') {
            this.errorMsg = '请选择处理方式'
            return
          } else {
            console.log(this.action)
          }
          let ip, port
          if (this.ipVal == '') {
            ip = '*'
          } else {
            ip = this.ipVal
          }
          if (this.portVal == '') {
            port = '*'
          } else {
            port = this.portVal
          }
          if (this.fileAction.length == 3) {
            if (this.action == 1) {
              val = ruleResult.NetWork('All', parentPath, ip, port, this.matchProc, this.childNum)
            } else {
              val = ruleResult.NetWorkOne('All', parentPath, ip, port, this.matchProc, this.childNum)
            }
            this.$emit('addRule', val)
            this.erroInit()
          } else {
            this.fileAction.forEach(el => {
              if (this.action == 1) {
                val = ruleResult.NetWork(el, parentPath, ip, port, this.matchProc, this.childNum)
              } else {
                val = ruleResult.NetWorkOne(el, parentPath, ip, port, this.matchProc, this.childNum)
              }
              this.$emit('addRule', val)
              this.erroInit()
            })
          }
          break
        case 6:
          if (this.parentProVal == '') {
            this.erroInit()
            this.errorMsg = '请选择进程类型'
            return
          } else {
            if (this.parentProVal != 'null') {
              let msg = this.$validateCenter.checkPro(this.parentProVal, this.parentVal)
              if (msg != '') {
                this.erroInit()
                this.errorMsg = msg
                this.parentError = true
                return
              }
            }
          }
          if (this.childProVal == '') {
            this.erroInit()
            this.errorMsg = '请选择回调类型'
            return
          }
          if (this.action == '') {
            this.erroInit()
            this.errorMsg = '请选择处理方式'
            return
          }
          val = ruleResult.CallBack(this.childProVal, parentPath, this.action, this.matchProc, this.childNum)
          this.$emit('addRule', val)
          this.erroInit()

          break
        case 8:
          if (this.parentProVal == '') {
            this.errorMsg = '请选择进程类型'
            return
          } else {
            if (this.parentProVal != 'null') {
              let msg = this.$validateCenter.checkPro(this.parentProVal, this.parentVal)
              if (msg != '') {
                this.erroInit()
                this.errorMsg = msg
                this.parentError = true
                return
              }
            }
          }

          let title = 'null'; let calss = 'null'; let width = 'null'; let height = 'null'; let yVal = 'null'; let xVal = 'null'; let style = 'null'; let style1 = 'null'; let styelResult = 'null'; let rect = 'null'
          this.title == '' ? title = 'null' : title = this.title
          this.calss == '' ? calss = 'null' : calss = this.calss
          this.width == '' ? width = 'null' : width = this.width
          this.height == '' ? height = 'null' : height = this.height
          this.yVal == '' ? yVal = 'null' : yVal = this.yVal
          this.xVal == '' ? xVal = 'null' : xVal = this.xVal
          this.style == '' ? style = 'null' : style = this.style
          this.style1 == '' ? style1 = 'null' : style1 = this.style1

          if (style1 == 'null') {
            styelResult = style
          } else {
            if (style != 'null') {
              styelResult = style + ';' + style1
            } else {
              styelResult = 'null'
            }
          }
          if (width == 'null' && height == 'null') {
            rect = 'null'
          } else {
            rect = width + 'x' + height
          }
          if (title != 'null') {
            if (title.length > 255) {
              this.erroInit()
              this.errorMsg = '字符长度不能大于255'
              this.childrenError3 = true
              return
            }
          }
          if (calss != 'null') {
            if (calss.length > 255) {
              this.erroInit()
              this.errorMsg = '字符长度不能大于255'
              this.childrenError4 = true
              return
            }
          }
          if (width != '' && width != 'null') {
            if (/[^\0-9\*\?]/g.test(width)) {
              this.erroInit()
              this.errorMsg = '格式错误'
              this.childrenError = true
              return
            }
            if (width.length > 4) {
              this.erroInit()
              this.errorMsg = '字符长度不能大于4'
              this.childrenError = true
              return
            }
          }

          if (height != '' && height != 'null') {
            if (/[^\0-9\*\?]/g.test(height)) {
              this.erroInit()
              this.errorMsg = '格式错误'
              this.childrenError2 = true
              return
            }
            if (height.length > 4) {
              this.erroInit()
              this.errorMsg = '字符长度不能大于4'
              this.childrenError2 = true
              return
            }
          }
          if (style != 'null') {
            if (style.length > 10) {
              this.erroInit()
              this.errorMsg = '字符长度不能大于10'
              this.childrenError5 = true
              return
            } else if (style1.length < 3) {
              this.erroInit()
              this.errorMsg = '字符长度不能小于3'
              this.childrenError6 = true
            }
          }
          if (style1 != 'null') {
            if (style1.length > 10) {
              this.erroInit()
              this.errorMsg = '字符长度不能大于10'
              this.childrenError6 = true
              return
            } else if (style1.length < 3) {
              this.erroInit()
              this.errorMsg = '字符长度不能小于3'
              this.childrenError6 = true
            }
          }
          if (this.action == '') {
            this.erroInit()
            this.errorMsg = '请选择处理方式'
            return
          }
          val = ruleResult.WindowCheck(parentPath, title, calss, styelResult, rect, this.action)
          this.$emit('addRule', val)
          this.erroInit()
          break
        case 14:
          if (this.parentProVal == '') {
            this.erroInit()
            this.errorMsg = '请选择进程类型'
            return
          } else {
            if (this.parentProVal != 'null') {
              let msg = this.$validateCenter.checkPro(this.parentProVal, this.parentVal)
              if (msg != '') {
                this.erroInit()
                this.errorMsg = msg
                this.parentError = true
                return
              }
            }
          }

          val = ruleResult.ProcStartIntercept(parentPath, selfPath, this.action)
          this.$emit('addRule', val)
          this.erroInit()
          break
        default:
          break
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.btnCon {
  padding-top: 20px;
}

.cardCon {
  margin-left: -24px;
}
</style>
<style lang="scss" >
.ivu-tabs-nav-wrap {
  background: #F5F7FA;
}

.cardCon {
  .ivu-tabs {
    border: 1px solid #DCDFE6;
    background: #fff;
    box-shadow: 0 10 10px rgba($color: #000000, $alpha: .5);
    width: calc(100% - 4px);
    border-radius: 4px;
  }

  .ivu-table:before {
    height: 0;
  }
}

.formCon {
  margin-top: 10px;
}
</style>
<style lang="scss">
.cardConRuleEditor{
  .ivu-input-number{
    border-radius: 0;
  }
}

.error {
  input {
    border-color: rgb(235, 43, 43) !important;
  }
}

.ivu-tabs-nav .ivu-tabs-tab {
  padding: 8px 10px;
}

.ivu-form-item {
  margin-bottom: 10px;
}

// .margin6 {
//   margin-left: 6px;
// }
.ivu-select {
  border-radius: none;
}

.modal-body .row {
  input {
    border-radius: 0 !important;
  }

  overflow: inherit !important;
}

.blue-btn {
  line-height: 16px;
}

.ivu-btn,
.ivu-input,
.ivu-select-selection,
.ivu-checkbox-border {
  border-radius: 0;
}

.ivu-checkbox-wrapper {
  margin-left: -1px;
  vertical-align: middle;
}

.ivu-input {
  font-size: 12px;
}
</style>